// export default {
//   USD: '$',
//   EUR: '€',
//   AED: 'د.إ',
//   ALL: 'L',
//   AMD: 'Դ',
//   ARS: '$',
//   AUD: 'A$',
//   AZN: '₼',
//   BDT: '৳',
//   BGN: 'Лв',
//   BMD: '$',
//   BRL: 'R$',
//   CAD: 'C$',
//   CDF: 'FC',
//   CHF: '₣',
//   CLP: '$',
//   CNY: '¥',
//   COP: '$',
//   CRC: '₡',
//   CZK: 'Kč',
//   DKK: 'Kr.',
//   GBP: '£',
//   GEL: '₾',
//   GHS: 'GH¢',
//   GTQ: 'Q',
//   HKD: 'HK$',
//   HRK: 'kn‎',
//   HTG: 'G',
//   HUF: 'Ft',
//   IDR: 'Rp',
//   ILS: '₪',
//   INR: '₹',
//   IQD: 'ع.د',
//   IRR: '﷼',
//   ISK: 'Íkr',
//   JPY: '¥‎',
//   KES: '/=',
//   KGS: 'Лв',
//   KRW: '₩',
//   KWD: 'د.ك',
//   KYD: '$',
//   KZT: '₸',
//   MAD: 'MAD',
//   MDL: 'L',
//   MKD: 'Ден',
//   MMK: 'K',
//   MNT: '₮',
//   MXN: 'Mex$',
//   MYR: 'RM',
//   NAD: 'N$',
//   NGN: '₦',
//   NOK: 'kr',
//   NZD: '$',
//   PEN: 'S/',
//   PLN: 'zł',
//   PYG: '₲',
//   RON: 'lei',
//   RUB: '₽',
//   SAR: '﷼‎',
//   SEK: 'kr',
//   SGD: 'S$',
//   SLL: 'Le',
//   THB: '฿',
//   TMT: 'T',
//   TND: 'د.ت',
//   TRY: '₺',
//   TWD: 'NT$',
//   TZS: 'TSh',
//   UAH: '₴',
//   UGX: 'USh',
//   UYU: '$U',
//   UZS: "so'm",
//   VND: '₫',
//   XAF: 'FCFA',
//   XOF: 'CFA',
//   ZAR: 'R',
//   ZMW: 'ZK',
//   BAM: 'KM',
//   PHP: '₱',
//   BYN: 'Rbl‎',
//   ETB: 'ብር',
//   PKR: 'Rs',
// }

export const Currencies: any = {
  '': {
    symbol: 'N/A',
    precision: 2,
  },
  USD: {
    symbol: '$',
    precision: 2,
  },
  EUR: {
    symbol: '€',
    precision: 2,
  },
  AED: {
    symbol: 'د.إ',
    precision: 2,
  },
  ALL: {
    symbol: 'L',
    precision: 2,
  },
  AMD: {
    symbol: 'Դ',
    precision: 2,
  },
  ARS: {
    symbol: '$',
    precision: 2,
  },
  AUD: {
    symbol: 'A$',
    precision: 2,
  },
  AZN: {
    symbol: '₼',
    precision: 2,
  },
  BDT: {
    symbol: '৳',
    precision: 2,
  },
  BGN: {
    symbol: 'Лв',
    precision: 2,
  },
  BMD: {
    symbol: '$',
    precision: 2,
  },
  BRL: {
    symbol: 'R$',
    precision: 2,
  },
  CAD: {
    symbol: 'C$',
    precision: 2,
  },
  CDF: {
    symbol: 'FC',
    precision: 2,
  },
  CHF: {
    symbol: '₣',
    precision: 2,
  },
  CNY: {
    symbol: '¥',
    precision: 2,
  },
  COP: {
    symbol: '$',
    precision: 2,
  },
  CRC: {
    symbol: '₡',
    precision: 2,
  },
  CZK: {
    symbol: 'Kč',
    precision: 2,
  },
  DKK: {
    symbol: 'Kr.',
    precision: 2,
  },
  GBP: {
    symbol: '£',
    precision: 2,
  },
  GEL: {
    symbol: '₾',
    precision: 2,
  },
  GHS: {
    symbol: 'GH¢',
    precision: 2,
  },
  GTQ: {
    symbol: 'Q',
    precision: 2,
  },
  HKD: {
    symbol: 'HK$',
    precision: 2,
  },
  HRK: {
    symbol: 'kn‎',
    precision: 2,
  },
  HTG: {
    symbol: 'G',
    precision: 2,
  },
  HUF: {
    symbol: 'Ft',
    precision: 2,
  },
  IDR: {
    symbol: 'Rp',
    precision: 2,
  },
  ILS: {
    symbol: '₪',
    precision: 2,
  },
  INR: {
    symbol: '₹',
    precision: 2,
  },
  // IQD: {
  //   symbol: 'ع.د',
  //   precision: 3,
  // },
  IRR: {
    symbol: '﷼',
    precision: 2,
  },
  KES: {
    symbol: '/=',
    precision: 2,
  },
  KGS: {
    symbol: 'Лв',
    precision: 2,
  },
  // KWD: {
  //   symbol: 'د.ك',
  //   precision: 3,
  // },
  KYD: {
    symbol: '$',
    precision: 2,
  },

  KZT: {
    symbol: '₸',
    precision: 2,
  },

  MAD: {
    symbol: 'MAD',
    precision: 2,
  },

  MDL: {
    symbol: 'L',
    precision: 2,
  },

  MKD: {
    symbol: 'Ден',
    precision: 2,
  },

  MMK: {
    symbol: 'K',
    precision: 2,
  },
  MNT: {
    symbol: '₮',
    precision: 2,
  },

  MXN: {
    symbol: 'Mex$',
    precision: 2,
  },

  MYR: {
    symbol: 'RM',
    precision: 2,
  },

  NAD: {
    symbol: 'N$',
    precision: 2,
  },

  NGN: {
    symbol: '₦',
    precision: 2,
  },

  NOK: {
    symbol: 'kr',
    precision: 2,
  },

  NZD: {
    symbol: '$',
    precision: 2,
  },

  PEN: {
    symbol: 'S/',
    precision: 2,
  },

  PLN: {
    symbol: 'zł',
    precision: 2,
  },

  PYG: {
    symbol: '₲',
    precision: 2,
  },

  RON: {
    symbol: 'lei',
    precision: 2,
  },

  RUB: {
    symbol: '₽',
    precision: 2,
  },

  SAR: {
    symbol: '﷼‎',
    precision: 2,
  },

  SEK: {
    symbol: 'kr',
    precision: 2,
  },

  SGD: {
    symbol: 'S$',
    precision: 2,
  },

  SLL: {
    symbol: 'Le',
    precision: 2,
  },

  THB: {
    symbol: '฿',
    precision: 2,
  },
  TMT: {
    symbol: 'T',
    precision: 2,
  },
  // TND: {
  //   symbol: 'د.ت',
  //   precision: 3,
  // },
  TRY: {
    symbol: '₺',
    precision: 2,
  },
  TWD: {
    symbol: 'NT$',
    precision: 2,
  },
  TZS: {
    symbol: 'TSh',
    precision: 2,
  },
  UAH: {
    symbol: '₴',
    precision: 2,
  },
  UGX: {
    symbol: 'USh',
    precision: 2,
  },
  UYU: {
    symbol: '$U',
    precision: 2,
  },
  UZS: {
    symbol: "so'm",
    precision: 2,
  },
  ZAR: {
    symbol: 'R',
    precision: 2,
  },
  ZMW: {
    symbol: 'ZK',
    precision: 2,
  },
  BAM: {
    symbol: 'KM',
    precision: 2,
  },
  PHP: {
    symbol: '₱',
    precision: 2,
  },
  BYN: {
    symbol: 'BYN',
    precision: 2,
  },
  ETB: {
    symbol: 'ብር',
    precision: 2,
  },
  PKR: {
    symbol: 'Rs',
    precision: 2,
  },
  EGP: {
    symbol: '£',
    precision: 2,
  },
  KHR: {
    symbol: '₭',
    precision: 2,
  },
  LAK: {
    symbol: '₭',
    precision: 2,
  },
  MVR: {
    symbol: 'Rf',
    precision: 2,
  },
  MBC: {
    symbol: 'mBTC',
    precision: 5,
  },
  FTN: {
    symbol: 'FTN',
    precision: 2
  },
  IRT: {
    symbol: 'IRT',
    precision: 2
  },
  MBT: {
    symbol: 'mBT',
    precision: 2
  },
  TJS: {
    symbol: 'TJS',
    precision: 2
  },
  SOS: {
    symbol: 'SOS',
    precision: 2
  },
  SDG: {
    symbol: 'SDG',
    precision: 2
  },
}
